import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=53e89d94&"
import script from "./FlashMessage.vue?vue&type=script&lang=js&"
export * from "./FlashMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports